import { formatBytes } from '@/services/download/downloadHelpers';

// Throttle pra evitar spam de toasts quando uma turma inteira falha por rede:
// só emite um toast a cada NETWORK_PAUSED_TOAST_THROTTLE_MS. Em downloadClass
// com N LOs falhando em cascata, antes seriam N toasts; agora 1. Compartilhado
// entre showNetworkPaused e showCellularBlocked (mesmo evento de raiz: rede
// indisponível ou inadequada — o user não precisa de 2 toasts diferentes em
// sequência).
let _lastNetworkPausedToastAt = 0;
const NETWORK_PAUSED_TOAST_THROTTLE_MS = 5000;

export function showInsufficientSpace (commit, err) {
  const need = formatBytes(err.estimatedBytes);
  const have = formatBytes(err.availableBytes);
  commit('toast/NEW', {
    type: 'error',
    message: `Espaço insuficiente para baixar. Necessário: ${need} · Disponível: ${have}`,
    duration: 7000
  }, { root: true });
}

export function showMissingCredentials (commit) {
  commit('toast/NEW', {
    type: 'error',
    message: 'Sessão expirada. Faça login novamente para baixar aulas.',
    duration: 7000
  }, { root: true });
}

// Vídeos hospedados em YouTube/Vimeo/MP4 progressivo não têm manifest HLS no
// nosso CDN — só rodam online via player do provider. Não é "erro": é limite
// técnico/contratual. Toast tipo "info" comunica isso sem alarmar.
export function showExternalProvider (commit) {
  commit('toast/NEW', {
    type: 'info',
    message: 'Esta aula está hospedada em uma plataforma externa e não pode ser baixada para uso offline.',
    duration: 6000
  }, { root: true });
}

// Toast usado quando user clica "baixar" enquanto a migração de cifragem ainda
// roda. Esperar 5s e retentar resolve na grande maioria dos casos (rmdir+nukeAll
// somam ~1-3s). Evita race onde o rmdir apaga arquivos recém-baixados.
export function showMigrationInProgress (commit) {
  commit('toast/NEW', {
    type: 'warning',
    message: 'Preparando armazenamento offline. Tente novamente em instantes.',
    duration: 5000
  }, { root: true });
}

export function showNetworkPaused (commit, loName) {
  const now = Date.now();
  if (now - _lastNetworkPausedToastAt < NETWORK_PAUSED_TOAST_THROTTLE_MS) return;
  _lastNetworkPausedToastAt = now;
  commit('toast/NEW', {
    type: 'warning',
    message: `Sem conexão. O download de "${loName}" será retomado de onde parou quando você tentar novamente.`,
    duration: 7000
  }, { root: true });
}

// Toast emitido quando um LO atinge MAX_AUTO_RETRY tentativas auto. Distinto
// de showNetworkPaused pra deixar claro que o user precisa intervir.
export function showRetryExhausted (commit, loName) {
  commit('toast/NEW', {
    type: 'warning',
    message: `Várias tentativas de baixar "${loName}" falharam. Toque no ícone pra tentar novamente.`,
    duration: 7000
  }, { root: true });
}

// Auto-resume bloqueado em cellular quando user não optou explicitamente.
// Compartilha o throttle de showNetworkPaused — info redundante a cada
// reconexão móvel não ajuda; o primeiro toast já transmite a info.
export function showCellularBlocked (commit) {
  const now = Date.now();
  if (now - _lastNetworkPausedToastAt < NETWORK_PAUSED_TOAST_THROTTLE_MS) return;
  _lastNetworkPausedToastAt = now;
  commit('toast/NEW', {
    type: 'info',
    message: 'Conexão móvel detectada. Conecte-se ao Wi-Fi pra retomar downloads automaticamente.',
    duration: 5000
  }, { root: true });
}
